var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEF2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FEE2E2",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 29.4999L30 36.4999M30 29.4999L37 36.4999M45.1667 32.9999C45.1667 39.4432 39.9434 44.6666 33.5 44.6666C27.0567 44.6666 21.8334 39.4432 21.8334 32.9999C21.8334 26.5566 27.0567 21.3333 33.5 21.3333C39.9434 21.3333 45.1667 26.5566 45.1667 32.9999Z",
    stroke: "#B91C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.31b290164a99305c80aefa9b56f97310.svg";
export { ForwardRef as ReactComponent };